package com.rainbowclubs.rainbow.domain.use_cases.login

import com.rainbowclubs.rainbow.data.cache.AuthCache

class IsUserLoggedInUseCase(
    private val authCache: AuthCache,
) {
    suspend fun run(): Result<Boolean> = try {
        Result.success(authCache.hasSession())
    } catch (e: Exception) {
        Result.failure(e)
    }
}
